export default "__VITE_ASSET__D0IQCow$__"